import { vnModule_knockoutJS } from "../../vendor/valnet/valnet_jslib/vnApp/vnModule_knockoutJS";
import { XMLHttpRequestHandler, XMLHttpRequestHandler_requestType } from "../../vendor/valnet/valnet_jslib/XMLHttpRequestHandler/XMLHttpRequestHandler";
import { header } from "./header";
import { vn_app_zone_notification } from "../../vendor/valnet/valnet_jslib/vnApp/vn_app_zone_notification";
import { vignettesEdit_template } from "../components/templates/vignettesEdit_template";

declare var ko: any;
declare var page: any;

export class vignettes_edit extends vnModule_knockoutJS {
    protected XHRHdl: XMLHttpRequestHandler;
    protected editForm: vignettesEdit_template;
    protected XHRHdlCaller: string;
    protected _isLeavePageWarningNeeded: boolean = true;

    protected getModuleName(){
        return 'vignettes_edit';
    }

    buildContent() : Array<Element> {

        this.editForm = new vignettesEdit_template('editForm', this.viewModel, this);
        let zoneHeader = this.getVnAppZone().app.getZoneByName('Header');
        let loadedModule = zoneHeader.loadedModule;
        (<header>loadedModule).setHeaderTitle('Vignettes Edit');

        return [this.editForm.build()];
    }

    public fillPage(): void {

        let idBrand = this.getVnAppZone().getApp().params.idBrand;
        if (idBrand) {
            this.editForm.setBrand(idBrand);
        }

        this.getFormData();
    }

    protected getFormData() {

        this.loadingIn(this.editForm.builtTemplate);

        let idVignette = this.getVnAppZone().getApp().params.id;

        let usrReq_url: string = '';
        let usrReq_params: Array<Array<string>> = [];

        let vm:any = this.editForm.getViewModelForRequest();
        vm.lockItem = true;

        usrReq_params.push(["data", ko.toJSON(vm)]);

        if(idVignette) {
            let idBrand = this.getVnAppZone().getApp().params.idBrand;
            let brandReq_url: string = '';
            if (idBrand) {
                brandReq_url = `/brand/${idBrand}`;
            }

            usrReq_url = `/api${brandReq_url}/tags/vignettes/get/${idVignette}`;
        }
        vm.lockItem = true;

        usrReq_params.push(["data", ko.toJSON(vm)]);

        this.XHRHdl = new XMLHttpRequestHandler(usrReq_url, usrReq_params, this);

        this.XHRHdl.onReadyStateFunction = this.onGetRequestReturn;
        this.XHRHdl.execute();
    }

    protected onGetRequestReturn(req, obj) {

        return function () {
            obj.manageResponse(req, obj, function () {

                let responseParsed = JSON.parse(req.request.response).data;

                if (responseParsed.vignette) {
                    obj.editForm.setVignette(responseParsed.vignette);

                    if (!obj.editForm.getIsBrandOwner()) {
                        obj.cancel();
                        return;
                    }
                }
                obj.editForm.setPermissions(responseParsed.permissions);
            });

            obj.loadingOut(obj.editForm.builtTemplate);
        }
    }

    protected buildSaveRequestUrl(): string {
        let brandUrl = this.isBrand() ? `/brand/${this.getBrandId()}` : '';
        let url: string = `/api${brandUrl}/tags/vignettes/save/`;
        return url;
    }

    public isBrand(): boolean {
        let number = Number(this.getBrandId());
        return Number.isInteger(number);
    }

    protected saveVignette() {
        // LOADING : starts
        this.loadingIn(this.editForm.builtTemplate);

        this.XHRHdlCaller = 'save';
        let formReq_url: string = this.buildSaveRequestUrl();

        let formReq_params: Array<Array<string>> = [];

        let subViewModel = JSON.parse(ko.toJSON(this.editForm.getViewModelForRequest()));
        formReq_params.push(['data', ko.toJSON(subViewModel)]);

        let XHRHdl: XMLHttpRequestHandler = new XMLHttpRequestHandler(formReq_url, formReq_params, this);
        XHRHdl.mode = XMLHttpRequestHandler_requestType.POST;

        XHRHdl.onReadyStateFunction = this.onSaveVignetteReturn;
        XHRHdl.execute();
    }

    protected onSaveVignetteReturn(req, obj) {
        return function () {
            obj.manageResponse(req, obj, function () {
                obj.getVnAppZone().notification = new vn_app_zone_notification(vn_app_zone_notification.TYPE_SUCCESS, 'vignettes saved successfully!');
                obj.releaseLock('save');
            });
            obj.loadingOut(obj.editForm.builtTemplate);
        }
    }

    private buildReleaseVignetteLockUrl() {
        let idVignette = this.getVnAppZone().getApp().params.id;
        let url: string = `tags/vignettes/release/${idVignette}`;

        let idBrand = this.getVnAppZone().getApp().params.idBrand;
        let urlBrand = '';
        if (idBrand) {
            urlBrand = `brand/${idBrand}/`;
        }

        let endpoint: string = `/api/${urlBrand}${url}`;

        return endpoint;
    }

    protected releaseLock(actionSource: string) {

        // request a lock release
        let usrReq_url = this.buildReleaseVignetteLockUrl();

        this.XHRHdlCaller = actionSource;
        let usrReq_params: Array<Array<string>> = [];
        this.XHRHdl = new XMLHttpRequestHandler(usrReq_url, usrReq_params, this);
        this.XHRHdl.mode = XMLHttpRequestHandler_requestType.POST;
        this.XHRHdl.onReadyStateFunction = this.onPostRequestReleaseLockReturn;
        this.XHRHdl.execute();
    }

    protected onPostRequestReleaseLockReturn(req, obj) {

        return function () {
            obj.manageResponse(req, obj, function () {

                let redirectionUrl = obj.getVnAppZone().app.getLastRoute();
                if (obj.XHRHdlCaller === 'save') {
                    redirectionUrl = obj.buildListRequestUrl();
                }

                page.redirect(redirectionUrl);
            });
        }
    }

    protected getTagsSuggestion(keyword, idElement) {

        if( "getTagsSuggestion" in this.XHRHdls ){
            this.XHRHdls["getTagsSuggestion"].cancelAndReset();
        }

        let subViewModel = {filter: {keyword: keyword, getNonSelectable: true}, idElement: idElement};
        let usrReq_url: string = `/api/brand/${this.getVnAppZone().app.params.idBrand}/search/tag/`;
        let usrReq_params: Array<Array<string>> = [];
        usrReq_params.push(["data", ko.toJSON(subViewModel)]);
        this.XHRHdls['getTagsSuggestion']= new XMLHttpRequestHandler(usrReq_url, usrReq_params, this);

        this.XHRHdls['getTagsSuggestion'].onReadyStateFunction = this.onGetTagsSuggestionReturn;
        this.XHRHdls['getTagsSuggestion'].execute();
    }

    protected onGetTagsSuggestionReturn(req, obj) {

        return function () {
            obj.manageResponse(req, obj, function(){

                let responseParsed = JSON.parse(req.request.response);

                if (responseParsed.data.tags) {
                    let x = responseParsed.data.idElement;

                    obj.editForm.setTagFilter(responseParsed.data.tags.map(tag => {
                        // tag.isSelectable = tag.details.isSelectable;
                        tag.isSelectable = !!tag.isSelectable;
                        return tag;
                    }));
                }

            });
        }
    }

    public getPreviewTag(idTag, idElement) {
        this.loadingIn(this.editForm.builtTemplate.querySelector(`#${idElement}`));

        if(idTag) {
            const idRequest: string = "getPreviewTagSpecs";
            const idBrand: string = this.getVnAppZone().app.params.idBrand;

            if(idRequest in this.XHRHdls){
                this.XHRHdls[idRequest].cancelAndReset();
            }

            let usrReq_url: string = `/api/brand/${idBrand}/tags/get/${idTag}`;
            let usrReq_params: Array<Array<string>> = [];

            this.XHRHdls[idRequest] = new XMLHttpRequestHandler(usrReq_url, usrReq_params, this);

            this.XHRHdls[idRequest].onReadyStateFunction = this.onGetPreviewTagReturn;
            this.XHRHdls[idRequest].execute();
        } else {
            this.editForm.setIndexedValues();
            this.loadingOut(this.editForm.builtTemplate.querySelector(`#${idElement}`));
        }
    }


    public onGetPreviewTagReturn(req, obj) {
        return function () {
            obj.manageResponse(req, obj, function () {

                let responseParsed = JSON.parse(req.request.response);

                const tag = responseParsed.tag;
                const specsValues = responseParsed.specsValues;
                const specDefaults = responseParsed.specDefaults;
                obj.editForm.setIndexedValues(tag, specsValues, specDefaults);
            });

            obj.loadingOut(obj.editForm.builtTemplate.querySelector('#previewContainer'));
        };
    }

    protected filterSimpleOnChange(idElement){
        this.editForm.updateTagForPreview();
    }

    protected buildListRequestUrl(): string {

        let url = '/categorization/vignettes/';
        let brandUrl = this.isBrand() ? `/brand/${this.getBrandId()}` : '';

        return `${brandUrl}${url}`;
    }

    protected cancel() {
        let idBrand = this.getVnAppZone().getApp().params.idBrand;
        let idVignette = this.getVnAppZone().getApp().params.id;

        if(idVignette) {
            page(`/brand/${idBrand}/categorization/vignettes/view/${idVignette}`);
        }
        else {
            page(`/brand/${idBrand}/categorization/vignettes`);
        }
    }

    protected getMemoryViewModel() {
    }

    public getBrandId(): number {
        return Number(this.getVnAppZone().app.params.idBrand);
    }
}



// WEBPACK FOOTER //
// ./js/modules/vignettes_edit.ts